import script from "/app/pages/Home/invoice_comparison.vue?type=script";
import { render } from "/app/pages/Home/invoice_comparison.vue?type=template";
script.render = render;
export default script;
